import * as msal from '@azure/msal-browser';
import AuthConfig, {apiTokenRequest} from '../app_config/authConfig';
import GnavAuthConfig from '../app_config/gnavAuthConfig';

import EnvConfig from "../app_config/envConfig";
import apiConfig from "../app_config/apiConfig";
import {Store} from '../store/store';
import {LOGIN, LOGOUT} from '../constants/reducerTypes';
import UtilityService from './utilityService';

// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const msie11 = ua.indexOf('Trident/');
const isIE = msie > 0 || msie11 > 0;

let userProfile;
let signInType;

// Create the main myMSALObj instance
// configuration parameters are located at authConfig.js
// const AuthConfig = GnavAuthConfig;
// const myMSALObj = new msal.PublicClientApplication(AuthConfig.msalConfig);

const myMSALObj = new msal.PublicClientApplication(AuthConfig.msalConfig);
let gnavAccessToken;
const signIn = async (method) => {
  signInType = isIE ? 'loginRedirect' : method;
  if (signInType === 'loginPopup') {
    return await myMSALObj
      .loginPopup(AuthConfig)
      .then(handleResponse)
      .catch(function (error) {
        console.log(error);
      });
  } if (signInType === 'loginRedirect') {
    return myMSALObj.loginRedirect(AuthConfig);
  }

};

const signOut = () => {
  const userProfile = window.localStorage.getItem('userProfile')
    ? JSON.parse(window.localStorage.getItem('userProfile'))
    : null;
  const spoToken = userProfile ? userProfile.spoToken : "";
  const accountId = userProfile ? userProfile.accountId : "";
  const logoutRequest = {
    account: myMSALObj.getAccountByHomeId(accountId),
    postLogoutRedirectUri: window.location.origin + '/#logout',
  };
  userLogout(spoToken, accountId);
  Store.dispatch({
    type: LOGOUT
  });
  return myMSALObj.logoutPopup(logoutRequest);
};

const getTokenPopup = async (request, account) => {
  request.account = account;
  const authConfigScope = request.scopes;
  request.scopes = GnavAuthConfig.scopes;
  const loginResponse = await myMSALObj.acquireTokenSilent(request).catch(async error => {
    console.log('silent token acquisition fails.');
    if (error instanceof msal.InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      console.log('acquiring token using redirect');
      myMSALObj.acquireTokenRedirect(request);
    } else {
      console.error(error);
    }
  });
  if (loginResponse !== undefined) {
    gnavAccessToken = loginResponse.accessToken;
    /* Store.dispatch({
      type: LOGIN,
      payload: userProfile,
    }); */
  }
  request.scopes = authConfigScope;
  return await myMSALObj.acquireTokenSilent(request).catch(async error => {
    console.log('silent token acquisition fails.');
    if (error instanceof msal.InteractionRequiredAuthError) {
      console.log('acquiring token using popup');
      return myMSALObj.acquireTokenPopup(request).catch(error => {
        console.error(error);
      });
    }
    console.error(error);

  });
};

// This function can be removed if you do not need to support IE
const getTokenRedirect = async (request, account) => {
  request.account = account;
  const authConfigScope = request.scopes;
  request.scopes = GnavAuthConfig.scopes;
  const loginResponse = await myMSALObj.acquireTokenSilent(request).catch(async error => {
    console.log('silent token acquisition fails.');
    if (error instanceof msal.InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      console.log('acquiring token using redirect');
      myMSALObj.acquireTokenRedirect(request);
    } else {
      console.error(error);
    }
  });
  if (loginResponse !== undefined) {
    gnavAccessToken = loginResponse.accessToken;

  }
  request.scopes = authConfigScope;
  return await myMSALObj.acquireTokenSilent(request).catch(async error => {
    console.log('silent token acquisition fails.');
    if (error instanceof msal.InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      console.log('acquiring token using redirect');
      myMSALObj.acquireTokenRedirect(request);
    } else {
      console.error(error);
    }
  });
};

//This is used to silently acquire access token for Custom scope (Sharepoint access)
const getTokenAcquireAsync = async () => {
  const {email} = Store.getState().authenticationData.userDetails;
  const account = myMSALObj.getAccountByUsername(email);

  isIE
    ? await getTokenRedirect(AuthConfig, account)
      .then(handleResponse)
      .catch(error => console.log("silent authentication error ", error))
    : await getTokenPopup(AuthConfig, account)
      .then(handleResponse)
      .catch(error => console.log("popup authentication error ", error));
}

const handleResponse = async (resp) => {
  if (resp) {
    const readToken = {accessToken: resp.accessToken, expiresOn: resp.expiresOn};
    let response = '';
    if (isIE) {
      response = await getTokenRedirect(apiTokenRequest, resp.account);
    }
    else {
      response = await getTokenPopup(apiTokenRequest, resp.account);
    }
    if (response) {
      const spoToken = await getSpoToken(response.accessToken, response.account).catch(error => console.log("Error in getting SPO token ", error));
      if (spoToken) {
        const expiresOn = Math.min(new Date(readToken.expiresOn).getTime(), new Date(response.expiresOn).getTime(), new Date(spoToken.expiresOn).getTime());
        dispatchUserProfile({...response, expiresOn, readToken: readToken.accessToken, spoToken: spoToken.accessToken});
      }
      // workaround for running the application with local environment
      else if (process.env.REACT_APP_ENVIRONMENT_NAME === "local") {
        const expiresOn = Math.min(new Date(readToken.expiresOn).getTime(), new Date(response.expiresOn).getTime());
        dispatchUserProfile({...response, expiresOn, readToken: readToken.accessToken, spoToken: ''});
      }
    }

  } else if (window.location.hash.indexOf('logout') < 0 && UtilityService.checkTokenExpiry()) {
    localStorage.clear();
    await signIn('loginRedirect');
  }
}

const getSpoToken = async (bearerToken, accountInfo) => {
  const spoUrl = `${apiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]}${apiConfig.endpointConfig.getSpoToken.endpoint}`;
  // const spoUrl = `https://api-clientdata-mvp.discover.ey.com/v1/data/getspotoken`;
  const options = {
    method: `${apiConfig.endpointConfig.getSpoToken.method}`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'AccountId': accountInfo && accountInfo.homeAccountId ? accountInfo.homeAccountId : '',
      'Authorization': `Bearer ${bearerToken}`
    }
  };
  const response = await fetch(spoUrl, options).catch(error => {throw error});
  const spoTokenRes = await response;
  if (spoTokenRes.ok) {
    const spoToken = spoTokenRes.json();
    return spoToken;
  }
  // eslint-disable-next-line no-else-return
  else {
    throw spoTokenRes;
  }
};

const userLogout = async (spoToken, accountId) => {
  const userProfile = window.localStorage.getItem('userProfile')
    ? JSON.parse(window.localStorage.getItem('userProfile'))
    : null;
  const accessToken = userProfile ? userProfile.accessToken : "";
  const apiUrl = `${apiConfig.baseUrl[process.env.REACT_APP_ENVIRONMENT_NAME]}${apiConfig.endpointConfig.userLogout.endpoint}`;
  const options = {
    method: `${apiConfig.endpointConfig.userLogout.method}`,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'AccountId': accountId ? accountId : '',
      'Authorization': `Bearer ${accessToken}`,
      'spoauthorization': spoToken ? spoToken : ''
    }
  };
  fetch(apiUrl, options).catch(error => {throw error});
};

const dispatchUserProfile = (payloadObj) => {

  let profileUrl = EnvConfig.peopleProfile.baseUrl + apiConfig.endpointConfig.peopleProfile.params;
  profileUrl = profileUrl ? profileUrl.replace("{email}", payloadObj.account.username) : "#";
  userProfile = {
    profileUrl: profileUrl,
    displayName: payloadObj.account.name,
    email: payloadObj.account.username,
    accountId: payloadObj.account.homeAccountId,
    accessToken: payloadObj.accessToken,
    readToken: payloadObj.readToken,
    tokenType: payloadObj.tokenType,
    scopes: payloadObj.scopes,
    expiresOn: payloadObj.expiresOn,
    spoToken: payloadObj.spoToken,
    account: payloadObj.account,
    gnavAccessToken: gnavAccessToken
  };
  Store.dispatch({
    type: LOGIN,
    payload: userProfile,
  });
}
const currentUserAccount = () => {
  const {email} = Store.getState().authenticationData.userDetails;
  const account = myMSALObj.getAccountByUsername(email);
  return account;
}
// Redirect: once login is successful and redirects with tokens, call Graph API

myMSALObj
  .handleRedirectPromise()
  .then(handleResponse)
  .catch(err => {
    console.error(err);
  });


const exportObj = {signIn, getTokenAcquireAsync, signOut, currentUserAccount};
export default exportObj;
